import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded$3 = ["className", "inline", "tag", "innerRef"];

var Form = function Form(props) {
  var className = props.className,
      inline = props.inline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = _objectWithoutProperties(props, _excluded$3);

  var classes = classNames(className, {
    'form-inline': inline
  });
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    ref: innerRef,
    className: classes
  }));
};

Form.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  inline: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
Form.defaultProps = {
  tag: 'form',
  children: null,
  className: '',
  inline: false,
  innerRef: null
};

var _excluded$2 = ["className", "valid", "tooltip", "tag"];

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      valid = props.valid,
      tooltip = props.tooltip,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, _excluded$2);

  var validMode = tooltip ? 'tooltip' : 'feedback';
  var classes = classNames(className, valid ? "valid-".concat(validMode) : "invalid-".concat(validMode));

  if (!valid) {
    attributes.invalid = 'true';
  }

  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

FormFeedback.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tag: PropTypes.string,
  className: PropTypes.string,
  valid: PropTypes.bool,
  tooltip: PropTypes.bool
};
FormFeedback.defaultProps = {
  tag: 'div',
  valid: false,
  children: null,
  className: '',
  tooltip: false
};

var _excluded$1 = ["children", "className", "row", "disabled", "check", "inline", "tag", "readonly"];

var FormGroup = function FormGroup(props) {
  var children = props.children,
      className = props.className,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      readonly = props.readonly,
      attributes = _objectWithoutProperties(props, _excluded$1);

  var classes = classNames(className, {
    'form-row': row,
    'form-check': check,
    'form-group': !check,
    'form-check-inline': check && inline,
    'align-items-center form-group-inline': inline,
    disabled: check && disabled
  }); // Add readonly prop to children if FormGroup is readonly

  var computedChildren = readonly ? React.Children.map(children, function (child) {
    var newChild = _objectSpread2({}, child);

    newChild.props = _objectSpread2(_objectSpread2({}, newChild.props), {}, {
      readonly: readonly
    });
    return newChild;
  }) : children;
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes,
    readOnly: readonly
  }), computedChildren);
};

FormGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  row: PropTypes.bool,
  check: PropTypes.bool,
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  tag: PropTypes.string,
  className: PropTypes.string,
  readonly: PropTypes.bool
};
FormGroup.defaultProps = {
  tag: 'div',
  children: null,
  row: false,
  check: false,
  inline: false,
  disabled: false,
  className: '',
  readonly: false
};

var _excluded = ["className", "inline", "color", "tag"];

var FormText = function FormText(props) {
  var className = props.className,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, _excluded);

  var classes = classNames(_defineProperty({
    className: className,
    'form-text': !inline
  }, "text-".concat(color), color));
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

FormText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  inline: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  color: PropTypes.string,
  className: PropTypes.string
};
FormText.defaultProps = {
  tag: 'small',
  color: 'muted',
  children: null,
  inline: false,
  className: ''
};

Form.FormFeedback = FormFeedback;
Form.FormGroup = FormGroup;
Form.FormText = FormText;

export { FormFeedback, FormGroup, FormText, Form as default };
//# sourceMappingURL=index.js.map
